import { FC } from 'react'
import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { RNHome } from '../helpers/routeNames'

export interface BreadcrumbItem {
	label: string
	path?: string
}

export const PageBreadcrumb: FC<{ items: BreadcrumbItem[] }> = ({
	items
}) => {
	const navigate = useNavigate()

	return (
		<div className="page-breadcrumb-bar">
			<Breadcrumb
				items={[
					{
						title: (
							<span
								style={{ cursor: 'pointer' }}
								onClick={() => navigate(RNHome)}>
								<HomeOutlined />
							</span>
						)
					},
					...items.map((item) => ({
						title: item.path ? (
							<span
								style={{ cursor: 'pointer' }}
								onClick={() => navigate(item.path!)}>
								{item.label}
							</span>
						) : (
							item.label
						)
					}))
				]}
			/>
		</div>
	)
}
